module.exports = __webpack_public_path__ + "static/media/0004_Small.c9ba1d94.jpg";